import Hero from '../components/layout/Hero.js';
import '../assets/css/common.css';
import img_st_2 from '../assets/imgs_optimized/img_st_2.webp';
import form_1 from '../assets/imgs_optimized/form_1.webp';
import form_2 from '../assets/imgs_optimized/form_2.webp';
import form_3 from '../assets/imgs_optimized/form_3.webp';
import form_4 from '../assets/imgs_optimized/form_4.webp';
import AboutUs from './AboutUs.js';
import logo_1 from '../assets/imgs_optimized/partners/pt_1.webp';
import logo_2 from '../assets/imgs_optimized/partners/pt_2.webp';
import logo_3 from '../assets/imgs_optimized/partners/pt_3.webp';
import logo_4 from '../assets/imgs_optimized/partners/pt_4.webp';
import logo_5 from '../assets/imgs_optimized/partners/logo_univ.webp';
import miPoster from '../assets/imgs_optimized/poster2.webp';


function Home() {
  return (
    <>
      <Hero />

      <AboutUs />

      <div className='flex justify-center mt-16 relative'>
        <img src={img_st_2} className="absolute w-full h-full z-0 user-select" style={{ objectFit: 'cover' }} alt='' />
        <div className='max-w-8xl flex items-center justify-center relative w-full py-12 px-5 lg:px-24'>
          <div className='flex items-center justify-center gap-28 flex-wrap z-10 text-white mt-6'>
            <div className='flex items-center flex-col'>
              <div className='relative flex justify-center items-center'>
                <img src={form_1} alt='' />
                <img src={form_2} alt='' className='absolute' />
              </div>
              <div className='text-3xl uppercase'>Inicio</div>
              <div className='font-thin text-lg'>01/09/2023</div>
            </div>
            <div className='flex items-center flex-col'>
              <div className='relative flex justify-center items-center'>
                <img src={form_1} alt='' />
                <img src={form_3} alt='' className='absolute' />
              </div>
              <div className='text-3xl uppercase'>Fecha de fin</div>
              <div className='font-thin text-lg'>31/08/2026</div>
            </div>
            <div className='flex items-center flex-col'>
              <div className='relative flex justify-center items-center'>
                <img src={form_1} alt='' />
                <img src={form_4} alt='' className='absolute' />
              </div>
              <div className='text-3xl uppercase'>Financiación</div>
              <div className='font-thin text-lg'>50.625 €</div>
            </div>
          </div>
        </div>
      </div>
              <h2 className='text-4xl text-tertiary border gradient-border-b pb-1 mt-14'>Resultados</h2>

{/* ===== PASO 2: AÑADE ESTE NUEVO BLOQUE DE CÓDIGO ===== */}
      <div className='flex justify-center mt-16'>
        <div className='mt-8 flex justify-center items-center flex-wrap gap-5'>
          <img 
            src={miPoster} 
            alt="Una descripción importante de tu imagen para la accesibilidad" 
            className="w-full h-auto rounded-lg shadow-lg" 
          />
        </div>
      </div>
      {/* ====================================================== */}

      <div className='flex justify-center mt-16 pb-24'>
        <div className='max-w-8xl relative w-full px-5 lg:px-24'>
          <h2 className='text-4xl text-tertiary border gradient-border-b pb-1 mt-14'>Patrocinadores</h2>
          <div className='mt-8 flex justify-center items-center flex-wrap gap-5'>
            {/* Tamaños de imagen recomendados, borrar después, si puede ser en formato svg */}
            <img src={logo_5} className='flex-1' style={{ maxWidth: "352px", maxHeight: "111px" }} alt='partner' />
            <img src={logo_1} className='flex-1' style={{ maxWidth: "352px", maxHeight: "111px" }} alt='partner' />
            <img src={logo_2} className='flex-1' style={{ maxWidth: "352px", maxHeight: "111px" }} alt='partner' />
            <img src={logo_3} className='flex-1' style={{ maxWidth: "352px", maxHeight: "111px" }} alt='partner' />
            <img src={logo_4} className='flex-1' style={{ maxWidth: "352px", maxHeight: "111px" }} alt='partner' />
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
